export default "__VITE_ASSET__63c01619__"